module.exports = __webpack_public_path__ + "static/media/G0142657_China-38.eb3ee741.png";